import { Empty } from 'antd'
import styled from 'styled-components'

interface EmptyPlaceholderProps {
  description?: string
}

const DEFAULT_DESCRIPTION = 'No Data Available'

const StyledEmpty = styled(Empty)`
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${({ theme }) => theme.token.colorBgContainer};
  color: ${({ theme }) => theme.token.colorText};
`

const EmptyPlaceholder = ({ description }: EmptyPlaceholderProps) => {
  return (
    <StyledEmpty
      description={description || DEFAULT_DESCRIPTION}
    />
  )
}

export default EmptyPlaceholder
